import './Spin.css';

const Spin = () => (
	<div className="loadingio-spinner-interwind-2k10woz599e">
		<div className="ldio-zsixqjsoyk">
			<div>
				<div>
					<div>
						<div />
					</div>
				</div>
				<div>
					<div>
						<div />
					</div>
				</div>
			</div>
		</div>
	</div>
);

export default Spin;
